import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useEffect, useRef, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {StepperComponent} from '../../../../../../../_metronic/assets/ts/components'
import {checkinAutoSchemas} from '../../../../../util/validationHoteleria'
import {CheckinAuto} from '../../../models/ckecking.model'
import {FormStep1} from '../forms/FormStep1'
import {FormStep2} from '../forms/FormStep2'
import {FormStep3} from '../forms/FormStep3'
import {FormStep4} from '../forms/FormStep4'
import {getTyPeDocumentSite} from '../../../../central/services'
import {useAuth} from '../../../../../hooks/useAuth'
import {getMasterModuleService} from '../../modules/services'

const inits: CheckinAuto = {
  operationType: '',
  errorCheck: false,
  fromStep1: false,
  loadingBooking: false,
  hasBookings: false,
  doctypes: [],
}

const CheckInAuto: FC = () => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(checkinAutoSchemas[0])
  const [initValues] = useState<CheckinAuto>(inits)
  const [currentStepIndex, setCurrentStepIndex] = useState(0)
  const {user} = useAuth()

  const methods = useForm<CheckinAuto>({
    defaultValues: initValues,
    resolver: yupResolver(currentSchema),
  })

  const {reset} = methods

  // const operationType = watch('operationType')

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
    setCurrentSchema(checkinAutoSchemas[currentStepIndex - 1])
    setCurrentStepIndex((prevIndex) => prevIndex - 1)
  }

  const getValueTypeDocumentBySite = async () => {
    const result = await getTyPeDocumentSite(user.id)
    const filterPriority = result.data?.filter((item: any) => item.EsPrioritario)
    if (filterPriority.length > 0) {
      methods.setValue('tipoDocumentoId', filterPriority[0].Codigo)
    } else {
      methods.setValue('tipoDocumentoId', '01')
    }
  }

  const getDocTypeList = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoDocumento',
      })
      const data = response.data.data
      const filterData = data.filter(
        (item) => item.codigo !== '12' && item.codigo !== '11' && item.codigo !== '06',
      )
      const mappedMaster = filterData.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        length: master.campoadicionaltxt1,
      }))
      methods.setValue('doctypes', mappedMaster)
      // setDocType(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    getValueTypeDocumentBySite()
    getDocTypeList()
  }, [])

  // const handleCheckIn = async (values: CheckinAuto) => {
  //   try {
  //     const {data: response} = await createCheckinService({
  //       ReservaId: values.ReservaId,
  //       CamaId: values.CamaId,
  //       HuespedId: values.HuespedId,
  //     })

  //     if (response.error) {
  //       setValue('errorCheck', true)
  //     }

  //     stepper.current?.goNext()
  //     setCurrentStepIndex((prevIndex) => prevIndex + 1)
  //   } catch (error) {
  //     // Handle error
  //   }
  // }

  // const handleCheckout = async (values: CheckinAuto) => {
  //   try {
  //     const {data: response} = await createCheckoutService({
  //       ReservaId: values.ReservaId,
  //       CamaId: values.CamaId,
  //       HuespedId: values.HuespedId,
  //     })

  //     if (response.error) {
  //       setValue('errorCheck', true)
  //     }

  //     stepper.current?.goNext()
  //     setCurrentStepIndex((prevIndex) => prevIndex + 1)
  //   } catch (error) {
  //     // Handle error
  //   }
  // }

  // const submitStep: SubmitHandler<CheckinAuto> = async (values) => {
  //   if (!stepper.current) {
  //     return
  //   }

  //   if (values.operationType === 'checkin') {
  //     handleCheckIn(values)
  //   } else {
  //     handleCheckout(values)
  //   }

  //   setCurrentSchema(checkinAutoSchemas[currentStepIndex])

  //   // if (currentStepIndex !== stepper.current.totatStepsNumber) {
  //   //   stepper.current.goNext()
  //   //   setCurrentStepIndex((prevIndex) => prevIndex + 1)
  //   // } else {
  //   //   //   stepper.current.goto(1)
  //   //   //   reset()
  //   // }
  // }

  const nextStep = () => {
    if (!stepper.current) {
      return
    }

    setCurrentSchema(checkinAutoSchemas[currentStepIndex])

    if (currentStepIndex !== stepper.current.totatStepsNumber) {
      stepper.current.goNext()
      setCurrentStepIndex((prevIndex) => prevIndex + 1)
    }
  }

  const goToFirstStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goto(1)
    setCurrentStepIndex(0)
    setCurrentSchema(checkinAutoSchemas[0])
    reset()
  }

  const goToStep = (index: number) => {
    if (!stepper.current) {
      return
    }
    stepper.current.goto(index)
    setCurrentStepIndex(index - 1)
    setCurrentSchema(checkinAutoSchemas[index - 1])
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  return (
    <div className='card'>
      <div className='card-body'>
        <div
          ref={stepperRef}
          className='stepper stepper-links d-flex flex-column pt-15'
          id='kt_create_account_stepper'
        >
          <div className='stepper-nav mb-5'>
            <div className='stepper-item current' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Operación</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Ingresar Datos</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Información</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Resultados</h3>
            </div>
          </div>

          <FormProvider {...methods}>
            <form
              className='mx-auto mw-600px w-100 pt-15 pb-10'
              id='kt_create_account_form'
              // onSubmit={handleSubmit(submitStep)}
            >
              {/* ... Repeat similar blocks for other steps ... */}

              {/* Solo renderiza el paso actual */}
              {currentStepIndex === 0 && <FormStep1 nextStep={nextStep} prevStep={prevStep} />}
              {currentStepIndex === 1 && (
                <FormStep2
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {currentStepIndex === 2 && (
                <FormStep3
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {currentStepIndex === 3 && (
                <FormStep4
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}

              {/* <div className='d-flex flex-stack pt-15'>
                {currentStepIndex !== 3 ? (
                  <div className='mr-2'>
                    <button
                      type='button'
                      className='btn btn-lg btn-light-primary me-3'
                      data-kt-stepper-action='previous'
                      onClick={prevStep}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr063.svg'
                        className='svg-icon-4 me-1'
                      />
                      Atras
                    </button>
                  </div>
                ) : (
                  <></>
                )}

                {stepper?.current?.currentStepIndex === 3 ? (
                  <div>
                    <button type='submit' className='btn btn-lg btn-primary me-3'>
                      <span className='indicator-label'>
                        {operationType === 'checkin' && 'CheckIn'}
                        {operationType === 'checkout' && 'CheckOut'}
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr064.svg'
                          className='svg-icon-3 ms-2 me-0'
                        />
                      </span>
                    </button>
                  </div>
                ) : (
                  <></>
                )}
              </div> */}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  )
}

export default CheckInAuto
